<template>
  <div>
    <ValidationProvider
      v-slot="{ errors }"
      rules="required"
    >
      <fieldset
        class="login-form__field input__wrap"
        :class="{ 'error-focus': errors.length > 0 }"
      >
        <input
          id="companyName"
          v-model="formData.companyName"
          type="text"
          name="companyName"
          class="login-form__field__input required"
          :class="{
            error: errors.length > 0,
            valid: formData.companyName.length > 0 && errors.length == 0,
          }"
          required
          @input="onInput"
          @change="onChange"
        >
        <label
          v-t="'INPUT_BUSINESS_NAME'"
          for="companyName"
          class="login-form__field__label"
        />
        <div
          v-if="errors.length > 0"
          class="error-tooltip__wrap"
        >
          <h4
            v-t="'INPUT_BUSINESS_NAME_ERROR'"
            class="menu-link up-text error-tooltip__content"
          />
          <p
            v-t="'INPUT_BUSINESS_NAME_ERROR_DESCRIPTION'"
            class="description"
          />
        </div>
      </fieldset>
    </ValidationProvider>
    <ValidationProvider
      v-slot="{ errors }"
      rules="required"
    >
      <fieldset
        class="login-form__field input__wrap"
        :class="{ 'error-focus': errors.length > 0 }"
      >
        <input
          id="firstName"
          v-model="formData.firstName"
          type="text"
          name="firstName"
          class="login-form__field__input required"
          :class="{
            error: errors.length > 0,
            valid: formData.firstName.length > 0 && errors.length == 0,
          }"
          required
        >
        <label
          v-t="'INPUT_FIRST_NAME'"
          for="firstName"
          class="login-form__field__label"
        />
        <div
          v-if="errors.length > 0"
          class="error-tooltip__wrap"
        >
          <h4
            v-t="'INPUT_FIRST_NAME_ERROR'"
            class="menu-link up-text error-tooltip__content"
          />
          <p
            v-t="'INPUT_FIRST_NAME_ERROR_DESCRIPTION'"
            class="description"
          />
        </div>
      </fieldset>
    </ValidationProvider>
    <ValidationProvider
      v-slot="{ errors }"
      rules="required"
    >
      <fieldset
        class="login-form__field input__wrap"
        :class="{ 'error-focus': errors.length > 0 }"
      >
        <input
          id="lastName"
          v-model="formData.lastName"
          type="text"
          name="lastName"
          class="login-form__field__input required"
          :class="{
            error: errors.length > 0,
            valid: formData.lastName.length > 0 && errors.length == 0,
          }"
          required
        >
        <label
          v-t="'INPUT_LAST_NAME'"
          for="lastName"
          class="login-form__field__label"
        />
        <div
          v-if="errors.length > 0"
          class="error-tooltip__wrap"
        >
          <h4
            v-t="'INPUT_LAST_NAME_ERROR'"
            class="menu-link up-text error-tooltip__content"
          />
          <p
            v-t="'INPUT_LAST_NAME_ERROR_DESCRIPTION'"
            class="description"
          />
        </div>
      </fieldset>
    </ValidationProvider>
    <ValidationProvider
      v-slot="{ errors }"
      rules="required|email"
    >
      <fieldset
        class="login-form__field input__wrap"
        :class="{ 'error-focus': errors.length > 0 }"
      >
        <input
          id="email"
          ref="emailInput"
          v-model="formData.email"
          type="email"
          name="email"
          class="login-form__field__input required"
          :class="{
            error: errors.length > 0,
            valid: formData.email.length > 0 && errors.length == 0,
          }"
          required
        >
        <label
          v-t="'INPUT_EMAIL'"
          for="email"
          class="login-form__field__label"
        />
        <div
          v-if="errors.length > 0"
          class="error-tooltip__wrap"
        >
          <h4
            v-t="'INPUT_EMAIL_ERROR'"
            class="menu-link up-text error-tooltip__content"
          />
          <p
            v-t="'INPUT_EMAIL_ERROR_DESCRIPTION'"
            class="description"
          />
        </div>
      </fieldset>
    </ValidationProvider>
    <ValidationProvider
      v-slot="{ errors }"
    >
      <fieldset
        class="login-form__field input__wrap"
        :class="{ 'error-focus': errors.length > 0 }"
      >
        <input
          id="phoneNumber"
          v-model="formData.phoneNumber"
          type="text"
          name="phoneNumber"
          class="login-form__field__input required"
          :class="{
            error: errors.length > 0,
            valid: formData.phoneNumber.length > 0 && errors.length == 0,
          }"
        >
        <label
          v-t="'INPUT_PHONE_NUMBER'"
          for="phoneNumber"
          class="login-form__field__label"
        />
        <div
          v-if="errors.length > 0"
          class="error-tooltip__wrap"
        >
          <h4
            v-t="'INPUT_PHONE_NUMBER_ERROR'"
            class="menu-link up-text error-tooltip__content"
          />
          <p
            v-t="'INPUT_PHONE_NUMBER_ERROR_DESCRIPTION'"
            class="description"
          />
        </div>
      </fieldset>
    </ValidationProvider>
    <ValidationProvider
      v-if="orpDetails.requireAgreementToTerms"
      v-slot="{ errors }"
      :rules="{ required: { allowFalse: false } }"
    >
      <fieldset
        class="login-form__field login-form__field--checkbox checkbox__wrap"
      >
        <input
          id="tos.checkbox"
          v-model="formData.agreedToTerms"
          type="checkbox"
          name="tos.checkbox"
          class="login-form__field__input--checkbox"
        >
        <label
          for="tos.checkbox"
          class="login-form__field__label login-form__field__label--checkbox"
        >

          <span v-if="orpDetails.isTermsAndConditionsURL">
            {{ $t("PRP_TERMS_PREFIX") }}&nbsp;&nbsp;<a
              :href="getTermsAndConditionsUrl"
              target="_BLANK"
            ><u>{{ $t("PRP_TERMS_LINK") }}</u></a>
          </span>
          <span v-if="!orpDetails.isTermsAndConditionsURL">
            {{ $t("PRP_TERMS_PREFIX") }}&nbsp;&nbsp;<a
              href="javascript:;"
              @click="openTermsAndConditions()"
            ><u>{{ $t("PRP_TERMS_LINK") }}</u></a>
          </span>

        </label>
        <transition name="backend-error-fade">
          <div
            v-show="errors.length > 0"
            class="text-center p-t-5"
          >
            <p
              v-t="'TERMS_EROR'"
              class="text-danger"
            />
          </div>
        </transition>
      </fieldset>
    </ValidationProvider>
  </div>
</template>

<script>

import messages from '../locales';

export default {
  components: {
  },
  
  model: {
    prop: 'value'
  },
  
  props: {
    orpDetails: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() { 
        return {
          description: '', 
          enabled: false,
          contactEmail: '',
          requireAgreementToTerms: false,
          isTermsAndConditionsURL: false,
          termsAndConditions: '',
          url: ''
        }; 
      }
    },
  },
  data: function () {
    return {
      formData: this.value,
      email: '',
      firstName: '',
      lastName: '',
      companyName: '',
      phoneNumber: '',
      agreedToTerms: false,
      openModal: false,
    };
  },
  computed: {
    getTermsAndConditionsUrl() {
      return this.orpDetails.termsAndConditions || '//www.ringba.com/terms';
    }
  },
  methods: { 
    onInput() {
      this.$emit('input', this.formData);
    },
    onChange() {
      this.$emit('change', this.formData);
    },
    openTermsAndConditions() {
      this.$emit('on-open-terms-and-conditions');
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>